import React from 'react';
import { Stack, Typography } from '@mui/material';

export const SimpleView = props => {
  const { data } = props;

  return (
    <Stack direction="column" spacing={1} padding={2}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3}>
        <Typography >Imię i nazwisko: </Typography>
        <Typography color="primary"><b>{data.name}</b></Typography>
      </Stack>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3}>
        <Typography >Nr. telefonu: </Typography>
        <Typography color="primary"><b>{data.phone}</b></Typography>
      </Stack>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3}>
        <Typography >E-mail: </Typography>
        <Typography color="primary"><b>{data.correspondence_email}</b></Typography>
      </Stack>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3}>
        <Typography >Rodzaj: </Typography>
        <Typography color="primary"><b>{data.type === 'contractor' ? 'Kontrahent' : data.type === 'guardian' ? 'Opiekun' : ''}</b></Typography>
      </Stack>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3}>
        <Typography >Miasto: </Typography>
        <Typography color="primary"><b>{data.city}</b></Typography>
      </Stack>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3}>
        <Typography >Kod pocztowy: </Typography>
        <Typography color="primary"><b>{data.postal_code}</b></Typography>
      </Stack>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3}>
        <Typography >Adres: </Typography>
        <Typography color="primary"><b>{data.street_address}</b></Typography>
      </Stack>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3}>
        <Typography >NIP: </Typography>
        <Typography color="primary"><b>{data.nip}</b></Typography>
      </Stack>
    </Stack>
  );
};
